import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { getRegion } from '../../utils/Region';

const NavigationWrapper = lazy(() =>
  import('../../components/NavigationWrapper'),
);

export const PrivateRoute = ({ component: Component }) => {
  if (!JSON.parse(localStorage.getItem('loginInfo.logged_user')))
    return <Navigate to={`/${getRegion()}/homeuser`} replace />;
  
  return (
    <NavigationWrapper>
      <Component />
    </NavigationWrapper>
  );
};
